import React from 'react';
import { LightContainer, Flex, FlexColumn } from '../../Reusable/Container';
import { Text } from '../../Reusable/Text';
import CountdownTimer from '../../Reusable/CountdownTimer';

const ExchangeRate = ({ internationalQuoteInfo, updating, getInternationalQuote, width }) => {
    return (
        <LightContainer background="#F3FAFF" borderColor="#F3FAFF" width={width ? width : "340px"} style={{ minWidth: 340 }}>
            <Flex between gap="8px" fullWidth>
                <FlexColumn start>
                    <Text>Exchange rate</Text>
                    <Text weight="600" primary className={`quote-field ${updating ? 'updating' : ''}`}>
                        1 USD = {internationalQuoteInfo?.conversionRate} {internationalQuoteInfo?.currency?.toUpperCase()}
                    </Text>
                    <Text margin="24px 0 0">Your rate refreshes every 60s</Text>
                </FlexColumn>
                <CountdownTimer onTimerComplete={getInternationalQuote} />
            </Flex>
        </LightContainer>
    );
};

export default ExchangeRate;
